export const server_base_endpoints = {
  general: {
    upload_files: "/general/upload-files",

    file_explorer: "/general/file-explorer",
    file_move: "/general/file-move",
    file_rename_folder: "/general/file-rename-folder",
    file_rename: "/general/file-rename",
    download_files: "/general/download-files",
    get_signed_url: "/general/get-signed-url",
    // get_table_columns: "/general/get-table-description",
    get_table_columns: "/template/get-table-or-column-name",
    get_table_column_info: "/general/get-column-info",
  },
  auth: {
    sign_in: "/authentication/login",
    sign_up: "/authentication/sign-up",
    validate_otp: "/authentication/validate-otp-get-token",
    forget_password: "/authentication/forget-password",
    logout: "/authentication/logout",
  },
  users: {
    get_users: "/user/get-user",
    upsert_profile: "/user/update-profile",
    create_new_user: "/user/upsert-user",
    change_password: "/user/change-user-pwd",
  },
  approvals: {
    get_approvals_count: "/approval/get-approval-count",
    upsert_approvals_count: "/approval/insert-approval-count",
    get_approval: "/approval/get-approval",
    upsert_approval: "/approval/handle-approval",
    get_my_approvals: "/approval/get-my-approvals",
    approve_reject_approval: "/approval/approve-reject-approval",
  },
  leads: {
    leads: {
      upsert_public_leads: "/lead/upsert-lead",
      upsert_private_leads: "/lead/auth-upsert-leads",
      get_private_leads: "/lead/get-leads",
      get_private_lead_suggestions: "/lead/lead-suggestion",
      get_private_lead_reports: "/lead/lead-reports",
      sign_document: "/lead/sign-document",
      signature_history: "/lead/signature-history",
      generate_signed_document: "/lead/generate-signed-document",
      get_retainer_agreement: "/lead/get-retainer",
      upsert_retainer_agreement: "/lead/retainer",
    },
    crs_draws: {
      upsert_crs_draws: "/lead/edit-crs_draws",
      get_crs_draws: "/lead/get-crs_draws",
    },
    noc_codes: {
      upsert_noc_codes: "/lead/edit-noc_codes",
      get_noc_codes: "/lead/get-noc_codes",
    },
    study_program: {
      upsert_study_programs: "/lead/edit-study",
      get_study_programs: "/lead/get-study",
    },
  },
  invoice: {
    get_product: "/invoice/get-product",
    upsert_product: "/invoice/upsert-product",

    get_invoice: "/invoice/get-invoice",
    get_invoice_details: "/invoice/get-invoice-and-invoice-items",
    upsert_invoice: "/invoice/upsert-invoice",
    get_invoice_item: "/invoice/get-invoice-item",

    upsert_soa: "/invoice/upsert-soa",
    get_soa: "/invoice/get-soa",
    get_soa_summary: "/invoice/get-soa-summary",
    get_old_soa: "/invoice/get-old-soa",
    sync_soa: "/invoice/sync-soa",
    upsert_bulk_soa_publish: "/invoice/upsert-bulk-soa-publish",
  },
  history: {
    get_history: "/history/get-history",
  },
  comments: {
    upsert_commnet: "/comment/upsert-comment",
    get_commnet: "/comment/get-comment",
  },
  configurations: {
    company: {
      upsert_company_private_info:
        "/companyInformation/upsert-company-information",
      get_company_private_info: "/companyInformation/get-company-information",
    },
  },
  security: {
    get_roles: "/security/get-roles",
    upsert_roles: "/security/upsert-roles",
    get_role_groups: "/security/get-role-groups",
    upsert_role_group: "/security/upsert-role-group",
    upsert_rmcap: "/security/upsert-role-module-content-access-permission",
  },
  questionnaire: {
    upsert_questionnaire: "/questionnaire/upsert-questionnaire",
    duplicate_questionnaire: "/questionnaire/duplicate-questionnaire",

    get_questionnaire: "/questionnaire/get-questionnaire",
    upsert_question: "/questionnaire/upsert-question",
    get_question: "/questionnaire/get-question",
    upsert_answer: "/questionnaire/upsert-answer",
    get_answer: "/questionnaire/get-answer",
    upsert_questions_options: "/questionnaire/upsert-questions-options",
    get_questions_options: "/questionnaire/get-questions-options",
    get_question_with_answer: "/questionnaire/get-question-answer",
  },
  services: {
    get_service: "/services/get-services",
    upsert_service: "/services/create-services",
  },
  customers: {
    upsert_customer: "/customer/upsert-customer",
    get_customers: "/customer/get-customer",
    upsert_customer_service: "/customer/upsert-customer-service",
    get_customer_services: "/customer/get-customer-service",
    upsert_customer_automation: "/customer/upsert-customer-automation",
    get_customer_automation: "/customer/get-customer-automation",
    upsert_customer_invoice: "/customer/upsert-customer-invoice",
    get_customer_invoice: "/customer/get-customer-invoice",
  },
  data_management: {
    upsert_branch: "/dataManagement/upsert-branch",
    get_branch: "/dataManagement/get-branch",
    get_enquiry: "/dataManagement/get-enquiry-request",
    get_referral: "/dataManagement/get-bni-click",
    upsert_referral: "/dataManagement/upsert-bni-click",
    get_record_counts: "/dataManagement/get-record-counts",
    get_soa_record_counts: "/dataManagement/get-soa-record-counts",
  },
  vouchers: {
    get_vouchers: "/package/get-voucher",
    create_voucher: "/package/upsert-voucher",
    update_voucher: "/package/upsert-voucher",
    delete_voucher: "/package/delete-voucher",
  },
  property: {
    get_property: "/property/get-property-private",
    create_property: "/property/create-property",
    upsert_property: "/property/upsert-property",
    get_property_areas: "/property/get-property-area",
    get_unassigned_property: "/property_owner/get-unassigned-property",
    get_lyp_referrals: "/property/get-list-your-property-referral",
    upsert_lyp_referral: "/property/upsert-list-your-property-referral",
    get_property_portfolio: "/property/get-property-portfolio",
    upsert_property_portfolio: "/property/upsert-property-portfolio",
    get_knowledge_base: "/property/get-knowledge-base",
    upsert_knowledge_base: "/property/upsert-knowledge-base",
    get_global_knowledge_base: "/property/get-global-knowledge-base",
    upsert_global_knowledge_base: "/property/upsert-global-knowledge-base",
  },
  inventory: {
    get_inventory: "/inventory/get-inventory",
    upsert_inventory: "/inventory/upsert-inventory",
    upsert_bulk_inventory: "/inventory/upsert-bulk-inventory",

    get_booking: "/inventory/get-booking",
    get_booking_report: "/inventory/get-booking-report",
    get_booking_report_initial: "/inventory/get-booking-report-initial",
    get_booking_report_count: "/inventory/get-booking-report-count",
    get_tedee_lock: "/lock/get-tedee-lock",
    get_tedee_lock_pin: "/lock/get-tedee-lock-pin",
    get_lock_pin_details: "/lock/get-lock-pin-detail",
    update_lock_pin: "/lock/update-lock-pin",
  },
  pms: {
    insert_property_with_pms: "/pms/insert-property-with-pms",
  },
  formulas: {
    // Booking Source
    upsert_booking_source: "/formulas/upsert-booking-source",
    get_booking_source: "/formulas/get-booking-source",
    get_booking_channel: "/formulas/get-booking-channel",
    // Formulas
    upsert_formula_calculator: "/formulas/upsert-formula-calculator",
    get_formula_calculator: "/formulas/get-formula-calculator-log",
    // Functions
    get_formula_internal_functions: "/formulas/get-libraries-and-propertie", // Get Internal Function
    get_formula_external_functions: "/formulas/get-internal-functions", // Get External Function
    get_formula_external_variable: "/formulas/get-formula-external-variable", // Get External Variables
    // Formula Validation
    validate_formula: "/formulas/check-formula", // Validate Formula

    // External Formulas
    upsert_external_formula: "/formulas/upsert-external-formula",
    get_external_formulas: "/formulas/get-external-formula",

    get_internal_formulas: "/formulas/get-internal-formula",
    upsert_internal_formulas: "/formulas/upsert-internal-formula",
  },
  payments: {
    get_charges: "/payments/get-charges",
    upsert_charges: "/payments/upsert-charges",
    get_manual_booking_payment: "/payments/get-manual-booking-payment",
    upsert_manual_booking_payment: "/payments/upsert-manual-booking-payment",
  },
  owner_management: {
    soa: {
      get_soa_statement: "/invoice/get-soa-statement",
      resend_publish_soa: "/invoice/resend-publish-soa",
    },

    property_owner: {
      upsert_property_owner: "/property_owner/upsert-owner",
      get_property_owner: "/property_owner/get-owner",
      get_owner_property: "/property_owner/get-owner-property",
    },

    first_report: {
      get_first_report: "/reports/get-final-budget-table-data",
      upsert_final_budget_table_data: "/reports/upsert-final-budget-table-data",
    },

    soa_summary: {
      get_new_owner_soa_summary: "/property_owner/get-owner-soa-summary",
      get_old_owner_soa_summary: "/property_owner/get-old-owner-soa-summary",
      get_invoice_product_items: "/invoice/get-invoice-item",
    },

    bookings: {
      get_owner_booking_report: "/property_owner/get-owner-booking-report",
    },

    properties: {
      get_owner_self_property: "/property_owner/get-owner-self-property",
    },
  },
  property_owner: {
    get_owner_bookings: "/property_owner/get-owner-bookings",
    dashboard_count: "/property_owner/dashboard-count",
    get_occupancy_count: "/property_owner/get-occupancy-count",
    get_adr_count: "/property_owner/get-adr-count",
    get_owner_booking_count_by_year: "/property_owner/booking-count-by-year",
  },
  guest: {
    upsert_guest_online: "/guest/upsert-guest-online",
    get_guest_online: "/guest/get-guest-online",
    get_guest_portfolio: "/guest/get-guest-portfolio",
    upsert_guest_portfolio: "/guest/upsert-guest-portfolio",
  },
  report: {
    get_area: "/reports/get-area-bed-size-based-on-property",
    get_area_bedsize: "/reports/get-area-bed-size-based-on-property",
    get_sku_property: "/reports/get-sku-property-based-on-area-bed-size",
    get_compset_on_area_and_bed_size:
      "/reports/get-compset-on-area-and-bed-size",
    get_adr_options: "/reports/get-adr-options",
    calculate_business_projection_data:
      "/reports/calculate-business-projection-data",
    get_business_projections_data: "/reports/get-business-projections-data",
    save_business_projections_data: "/reports/save-business-projections-data",
    upsert_report_by_preference_filter:
      "/reports/upsert-report-by-preference-filter",
    get_report_by_preference_filter: "/reports/get-report-by-preference-filter",
  },
  quotation: {
    upsert_quotation: "/quotation/upsert-quotation",
    get_quotation: "/quotation/get-quotation",
    preview_or_download_quotation: "/quotation/get-pdf-preview-quotation",
    get_agent: "/quotation/get-agent",
  },
  bookings: {
    get_booking_report_initial: "/inventory/get-booking-report-initial",
  },
  campaigns: {
    upsert_campaign_rule_templates: "/campaign/upsert-campaign-rule-templates",
    get_campaign_rule_template: "/campaign/get-campaign-rule-templates",


    voice: {

      save_voice_call_campaign: "/voiceCall/save-voice-call-campaign",
      get_voice_call_campaign: "/voiceCall/get-voice-call-campaign",

      save_voice_call_log: "/voiceCall/save-voice-call-log",
      get_voice_call_log: "/voiceCall/get-voice-call-log",

      get_voice_call_log_history: "/voiceCall/get-voice-call-log-history",

      save_voice_call_log_in_bulk: "/voiceCall/save-voice-call-log-in-bulk",

      update_lead_in_campaign: "/voiceCall/update-lead-in-campaign",

      stop_or_resume_dialing: "/voiceCall/stop-or-resume-dialing"

    }
  },
  siteConfiguration: {
    upsert_user_setting: "/siteConfiguration/upsert-user-setting",
  },


  subscriptions: {
    addons: {
      upsert: "/upsert-addon-master",
      get: "/subscription/get-addon-master"
    },
    save_addon: "/save-addon-at-subscription-time"
  }
};
